import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AppCommonsModule } from '../../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { ImageInfoRendererComponent } from './image-info-renderer.component';

/**
 * 画像情報 モジュール設定クラス
 *
 * @export ImageInfoRendererModule
 * @class ImageInfoRendererModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    ImageInfoRendererComponent
  ],
  providers: [
  ],
  exports: [
    ImageInfoRendererComponent,
  ]
})
export class ImageInfoRendererModule {
}
